import { useCallback, useState, Dispatch, SetStateAction } from "react";
import { IBlock } from "../BlockList/Block";

/**
 * Hook to manage block search and filtering
 */
export function useBlockSearch(blocks: IBlock[]): {
	blocksShowing: IBlock[];
	handleSearchChange: (value: string) => void;
	setBlocksShowing: Dispatch<SetStateAction<IBlock[]>>;
} {
	const [blocksShowing, setBlocksShowing] = useState<IBlock[]>(blocks);

	const handleSearchChange = useCallback(
		(value: string) => {
			const filteredBlocks = blocks.filter((block) => {
				const name = block.primaryText.toLowerCase();
				const number = block.secondaryText?.toLowerCase();
				value = value.toLowerCase();
				return name.includes(value) || number?.includes(value);
			});
			setBlocksShowing(filteredBlocks);
		},
		[blocks],
	);

	return {
		blocksShowing,
		handleSearchChange,
		setBlocksShowing,
	};
}
